import React from 'react'

const Pharagraph = ({ value, className }) => {
    return (
        <p className={`mb-4 ${className}`}>{value}</p>
    )
}

export default Pharagraph